import React from "react";
import { useLocation } from "react-router-dom";
import styled, { css } from "styled-components";
import { Box } from "orcs-design-system";
import themeGet from "@styled-system/theme-get";
import PropTypes from "prop-types";
import { useAISidebar } from "src/hooks/useAISidebar";
import AIChatInterface from "./AIChatInterface";
import { AIChatProvider } from "./context/AIChatProviderWithAgentCore";
import { SOURCE_TYPES } from "./consts";

const AIChatWindowWrapper = styled(Box)`
  ${({ isOpen }) =>
    !isOpen &&
    css`
      display: none;
    `}

  ${({ aiViewMode }) =>
    aiViewMode === "fullscreen" &&
    css`
      flex: 1;
      padding: ${themeGet("space.r")};
    `}
`;

const AIChatWindow = ({ isOpen }) => {
  const { closeAI } = useAISidebar();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const aiViewMode = query.get("aiViewMode");
  const containerWidth =
    aiViewMode === "fullscreen"
      ? undefined
      : ["100%", "280px", "300px", "350px", "360px", "380px"];

  return (
    <AIChatWindowWrapper
      aiViewMode={aiViewMode}
      isOpen={isOpen}
      width={containerWidth}
    >
      <AIChatInterface
        variant={aiViewMode === "fullscreen" ? "fullpage" : "sidebar"}
        showCloseButton={true}
        onClose={closeAI}
        headerTitle="Ask TeamForm"
        showChatHistoryToggle={true}
        showNewChatButton={true}
      />
    </AIChatWindowWrapper>
  );
};

AIChatWindow.propTypes = {
  isOpen: PropTypes.bool.isRequired,
};

const AIChatWindowWithAgentCore = ({ isOpen }) => {
  return (
    <AIChatProvider sourceId={SOURCE_TYPES.chat_q_and_a} subjectId="custom">
      <AIChatWindow isOpen={isOpen} />
    </AIChatProvider>
  );
};

AIChatWindowWithAgentCore.propTypes = {
  isOpen: PropTypes.bool.isRequired,
};

export default AIChatWindowWithAgentCore;
